import React from 'react';
import { Container } from "@mui/material";
import banner from '../../img/banner.png';
import ScheduleButton from '../ScheduleButton/scheduleButton';


function Banner() {
  return (
    <div className="banner-background">
      <Container className="banner-container">
        <Container>
          <img src={banner} className="banner banner-animation" alt="banner" />
        </Container>
        <Container>
          <ScheduleButton isBanner />
        </Container>
      </Container>
    </div>
  );
}

export default Banner;